import type {
  AttachmentClassificationRequest,
  AttachmentClassificationResponse,
  GetAttachmentClassificationListRequest,
  GetListResponseOfAttachmentClassificationResponse,
} from 'src/api/ProactApiClient';
import {attachmentClassificationApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const attachmentClassificationApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getAttachmentClassificationList: builder.query<
      GetListResponseOfAttachmentClassificationResponse,
      GetAttachmentClassificationListRequest
    >({
      queryFn: clientQuery(params =>
        attachmentClassificationApiClient.list(params)
      ),
      providesTags: ['AttachmentClassifications'],
    }),
    getAttachmentClassification: builder.query<
      AttachmentClassificationResponse,
      number
    >({
      queryFn: clientQuery(id => attachmentClassificationApiClient.get(id)),
      providesTags: ['AttachmentClassifications'],
    }),
    createAttachmentClassification: builder.mutation<
      AttachmentClassificationResponse,
      AttachmentClassificationRequest
    >({
      queryFn: clientQuery(request =>
        attachmentClassificationApiClient.create(request)
      ),
      invalidatesTags: ['AttachmentClassifications'],
    }),
    updateAttachmentClassification: builder.mutation<
      AttachmentClassificationResponse,
      AttachmentClassificationRequest
    >({
      queryFn: clientQuery(request =>
        attachmentClassificationApiClient.update(request)
      ),
      invalidatesTags: ['AttachmentClassifications'],
    }),
    deleteAttachmentClassification: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => attachmentClassificationApiClient.delete(id)),
      invalidatesTags: ['AttachmentClassifications'],
    }),
  }),
});

export const {
  useGetAttachmentClassificationListQuery,
  useGetAttachmentClassificationQuery,
  useCreateAttachmentClassificationMutation,
  useUpdateAttachmentClassificationMutation,
  useDeleteAttachmentClassificationMutation,
} = attachmentClassificationApi;
